import React, { Suspense } from 'react';
import {LoaderInfo} from './../components/AppRoutes/LoaderInfo';
import EmptyDashboard from './../pages/dashboard/EmptyDashboard';
import AppRouter from './AppRouter';

const Wrapper = ({children}: any) => <>{children}</>

const KRouter = ({userDetails, initialized}: any) => {

    return (<>
      {!!userDetails  && initialized?
    <>
      <Suspense fallback={<EmptyDashboard/>}>
       <AppRouter Wrapper={Wrapper}/>
    </Suspense>
    </> : <LoaderInfo /> }
    </>
    );
};

export default KRouter;
